<template>
  <div class="max-w-3xl w-full mx-auto space-y-6">
    <h1 class="text-2xl font-bold text-gray-800">Choose an admin action</h1>
    <div class="grid md:grid-cols-2 gap-6">
      <div class="border rounded-lg p-6 bg-white shadow-sm flex flex-col">
        <h2 class="text-lg font-semibold mb-2">Clip Source Upload</h2>
        <p class="text-sm text-gray-600 mb-4">Upload a source video for a ceremony.</p>
        <router-link
          class="mt-auto inline-flex items-center px-4 py-2 border border-gray-300 rounded-md bg-white hover:bg-gray-50"
          to="/admin/upload"
        >
          Go to Clip Upload
        </router-link>
      </div>

      <div class="border rounded-lg p-6 bg-white shadow-sm flex flex-col" :class="{ 'opacity-50': !canSnapshotUpload }">
        <h2 class="text-lg font-semibold mb-2">Snapshot Bulk Upload</h2>
        <p class="text-sm text-gray-600 mb-4">Upload multiple images for a ceremony using presigned URLs.</p>
        <div v-if="!canSnapshotUpload" class="text-xs text-red-600 mb-3">
          You don’t have the snapshot-upload role.
        </div>
        <router-link
          v-if="canSnapshotUpload"
          class="mt-auto inline-flex items-center px-4 py-2 border border-gray-300 rounded-md bg-white hover:bg-gray-50"
          to="/admin/snapshot-bulk"
        >
          Go to Snapshot Uploader
        </router-link>
        <button v-else disabled class="mt-auto inline-flex items-center px-4 py-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed">
          Access restricted
        </button>
      </div>
    </div>
  </div>
</template>

<script>
function decodeJwt(token) {
  try {
    const part = token.split('.')[1]
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decodeURIComponent(escape(json)))
  } catch (e) {
    return {}
  }
}

export default {
  name: 'ChooseAction',
  created() {
    // If the user doesn't have snapshot-upload role, auto-redirect to clip upload
    if (!this.canSnapshotUpload) {
      this.$router.replace('/admin/upload')
    }
  },
  computed: {
    canSnapshotUpload() {
      const token = localStorage.getItem('token') || ''
      const payload = decodeJwt(token)
      const roles = payload?.roles || []
      return Array.isArray(roles) && (roles.includes('snapshot-upload') || roles.includes('admin'))
    }
  }
}
</script>

<style scoped>
</style>
